import React, { Component } from "react";
import './index.scss';
//https://www.html.cn/archives/5824

export default class Loading extends Component {
  render() {
    return this.props.loading ? <div className="loader" /> : <div></div>;
  }
}
